import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Button, Table, Popover} from 'antd'
import {EyeOutlined} from '@ant-design/icons'
import {toJS} from 'mobx'
import {getPaginationConfig} from '../../../components/pagination'
import moment from 'moment'
import BatchDetailModal from './BatchDetailModal'
import {withTranslation} from 'react-i18next'

@inject('jobManagementStore')
@observer
class LogModal extends Component {
  formRef = React.createRef()
  state = {
    batchModalVisible: false,
    batchId: null,
    timer: null
  }

  componentDidMount() {
    this.setTimer()
  }

  clearTimer = () => {
    clearInterval(this.state.timer)
  }

  setTimer = () => {
    const {jobManagementStore, jobId, type} = this.props
    const {pageNoLog, pageSizeLog} = jobManagementStore
    if (jobId && type === '3') {
      let params = {
        'jobId': jobId,
        'page': pageNoLog,
        'size': pageSizeLog,
      }
      this.setState({
        timer: setInterval(() => {
          jobManagementStore.onDetailsJobAction(params).then()
        }, 5000)
      })
    }
  }

  handlePageChange = (page, pageSize) => {
    const {jobManagementStore} = this.props
    jobManagementStore.onChangePageLogAction(page, pageSize)
  }

  handleCheck = batchId => {
    const {jobManagementStore} = this.props
    jobManagementStore.getBatchDetail(batchId).then(() => {
      this.clearTimer()
      this.setState({batchModalVisible: true, batchId})
    })
  }

  batchModalCancel = () => {
    this.setTimer()
    this.setState({batchModalVisible: false})
  }

  logModalCancel = () => {
    const {handleCancel} = this.props
    this.clearTimer()
    handleCancel()
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {jobManagementStore, logModalVisible, type, t} = this.props
    const {pageNoLog, pageSizeLog, itemCountLog, logList} = jobManagementStore
    const {batchModalVisible, batchId} = this.state
    const pagination = getPaginationConfig(pageNoLog, pageSizeLog, itemCountLog, this.handlePageChange)
    return (
      <>
        <Modal
          title={t(`job.jobLog`)}
          visible={logModalVisible}
          // onOk={this.handleOk}
          onCancel={this.logModalCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width="80%"
          footer={null}
        >
          <Table dataSource={toJS(logList)} pagination={pagination} rowKey={type === '3' ? 'batchId' : 'id'} rowClassName={this.getRowClassName}>
            <Table.Column title={t(`job.status`)} dataIndex="status" key="status"/>
            <Table.Column title={t(`job.startTime`)} dataIndex="startTime" key="startTime"
                          render={(text) => moment(text).format('YYYY-MM-DD HH:mm:ss')}/>
            <Table.Column title={t(`job.endTime`)} dataIndex="endTime" key="endTime" render={(text) => moment(text).format('YYYY-MM-DD HH:mm:ss')}/>
            <Table.Column title={t(`job.duration`)} dataIndex="duration" key="duration"/>
            {
              type === '3' ?
                <Table.Column width={140} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
                  <Button type="link" icon={<EyeOutlined/>} onClick={() => this.handleCheck(record.batchId)} title={t(`general.display`)}/>
                )}/> :
                <Table.Column title={t(`job.messageId`)} dataIndex="messageIds" render={(text) => (
                  text ? <Popover content={text?.split(',')?.map(item => (<span style={{display: 'block'}}>{item}</span>))}
                                  style={{color: '#007aff'}}>{text?.split(',')[0]}...</Popover> : null
                )}/>
            }
          </Table>
        </Modal>

        {
          batchModalVisible ?
            <BatchDetailModal batchModalVisible={batchModalVisible} batchId={batchId} handleCancel={this.batchModalCancel}/> : null
        }
      </>
    )
  }
}

export default withTranslation()(LogModal)
